import alt from 'components/Dispatcher';
import SearchSource from 'sources/SearchSource';
import SearchActions from 'actions/SearchActions';

export class SearchStore{
  constructor() {
    this.state = {
      keyword: '',
      first: 0,
      maxCount: 20,
      tab: 4,
      products: [],
      medias: [],
      albums: [],
      features: [],
      users: [],
      height: 0,
      loading: false,
      hasMore: true
    };
    this.registerAsync(SearchSource);
    this.bindListeners({
      handleFetchProducts: SearchActions.FETCH_PRODUCTS,
      handleFetchMedias: SearchActions.FETCH_MEDIAS,
      handleFetchAlbums: SearchActions.FETCH_ALBUMS,
      handleFetchFeatures: SearchActions.FETCH_FEATURES,
      handleFetchUsers: SearchActions.FETCH_USERS,
      handleClearData: SearchActions.CLEAR_DATA,
      handleUpdateProducts: SearchActions.UPDATE_PRODUCTS,
      handleUpdateMedias: SearchActions.UPDATE_MEDIAS,
      handleUpdateAlbums: SearchActions.UPDATE_ALBUMS,
      handleUpdateFeatures: SearchActions.UPDATE_FEATURES,
      handleUpdateUsers: SearchActions.UPDATE_USERS,
      handleFetchLoading: SearchActions.FETCH_LOADING,
      handleFetchSuccess: SearchActions.FETCH_SUCCESS,
      handleFetchError: SearchActions.FETCH_ERROR,
      handleUpdateTab: SearchActions.UPDATE_TAB,
      handleUpdateKeyword: SearchActions.UPDATE_KEYWORD,
      handleUpdateHeight: SearchActions.UPDATE_HEIGHT
    });
  }
  handleUpdateTab(tab){
    this.setState({tab: tab})
  }
  handleUpdateKeyword(keyword){
    this.setState({keyword: keyword})
  }
  handleUpdateHeight({tab,height}){
    this.setState({tab: tab, height: height})
  }
  handleFetchProducts(keyword){
    let first = this.state.products.length ? this.state.products.length + 1 : 0;
    this.setState({first: first, loading: true, keyword });
    this.getInstance().searchRemoteProducts();
  }
  handleFetchMedias(keyword){
    let first = this.state.medias.length ? this.state.medias.length + 1 : 0;
    this.setState({first: first, loading: true, keyword });
    this.getInstance().searchRemoteMedias();
  }
  handleFetchAlbums(keyword){
    let first = this.state.albums.length ? this.state.albums.length + 1 : 0;
    this.setState({first: first, loading: true, keyword });
    this.getInstance().searchRemoteAlbums();
  }
  handleFetchFeatures(keyword){
    let first = this.state.features.length ? this.state.features.length + 1 : 0;
    this.setState({first: first, loading: true, keyword });
    this.getInstance().searchRemoteFeatures();
  }
  handleFetchUsers(keyword){
    let first = this.state.users.length ? this.state.users.length + 1 : 0;
    this.setState({first: first, loading: true, keyword });
    this.getInstance().searchRemoteUsers();
  }
  handleClearData(tab){
    if(tab == 'all'){
      this.setState({
        products: [],
        medias: [],
        albums: [],
        features: [],
        users: [],
        first: 0,
        loading: false,
        hasMore: true
      })
    }else if(tab == 'products'){
      this.setState({
        products: []
      })
    }else if(tab == 'medias'){
      this.setState({
        products: []
      })
    }else if(tab == 'albums'){
      this.setState({
        albums: []
      })
    }else if(tab == 'features'){
      this.setState({
        features: []
      })
    }else if(tab == 'users'){
      this.setState({
        users: []
      })
    }
  }
  handleUpdateProducts(products){
    let more = products.length === this.state.maxCount;
    let list = this.state.products.concat(products);
    this.setState({products: list, loading: false, hasMore: !list.length||more});
  }
  handleUpdateMedias(medias){
    let more = medias.length === this.state.maxCount;
    let list = this.state.medias.concat(medias);
    this.setState({medias: list, loading: false, hasMore: !list.length||more});
  }
  handleUpdateAlbums(albums){
    let more = albums.length === this.state.maxCount;
    let list = this.state.albums.concat(albums);
    this.setState({albums: list, loading: false, hasMore: !list.length||more});
  }
  handleUpdateFeatures(features){
    let more = features.length === this.state.maxCount;
    let list = this.state.features.concat(features);
    this.setState({features: list, loading: false, hasMore: !list.length||more});
  }
  handleUpdateUsers(users){
    let more = users.length === this.state.maxCount;
    let list = this.state.users.concat(users);
    this.setState({users: list, loading: false, hasMore: !list.length||more});
  }
  handleFetchLoading(loading){

  }
  handleFetchSuccess(){

  }
  handleFetchError(){

  }
}

export default alt.createStore(SearchStore, 'SearchStore');



// WEBPACK FOOTER //
// ./src/stores/SearchStore.js